import type { ReportTone } from '@codepass/shared';

/**
 * A report cell's tint, and the swatch that explains it - the capacity calendar's weeks, on the
 * report's table and on its calendar. One place, so the two cannot drift apart.
 */
export const TONE_CELL: Record<ReportTone, string> = {
  success: 'bg-success/15',
  warning: 'bg-warning/20',
  danger: 'bg-danger/15',
  neutral: 'bg-line/60 text-ink-muted',
};

export const TONE_SWATCH: Record<ReportTone, string> = {
  success: 'bg-success/40',
  warning: 'bg-warning/50',
  danger: 'bg-danger/40',
  neutral: 'bg-line',
};
